// Meta Pixel (Facebook Pixel) integration
const META_PIXEL_ID = '932263746333538'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

let initialized = false

export function initMetaPixel(pixelId: string = META_PIXEL_ID) {
  if (typeof window === 'undefined') return
  if (initialized) return
  if (!pixelId) return
  ;(function (f: any, b: any, e: string, v: string, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
  initialized = true
}

export function trackPixelEvent(
  eventName: string,
  params?: Record<string, unknown>,
) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', eventName, params)
}

// Initialize immediately when this module is loaded in the browser.
// This makes the pixel detectable by Meta Pixel Helper on initial page load,
// matching the behavior of placing the snippet directly in <head>.
if (typeof window !== 'undefined') {
  initMetaPixel()
}
